import { render, staticRenderFns } from "./SolveProblem.vue?vue&type=template&id=f2b6c730&scoped=true&"
import script from "./SolveProblem.vue?vue&type=script&lang=js&"
export * from "./SolveProblem.vue?vue&type=script&lang=js&"
import style0 from "./SolveProblem.vue?vue&type=style&index=0&id=f2b6c730&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b6c730",
  null
  
)

export default component.exports